import React, { useEffect, useState } from 'react';

import cx from 'classnames';

import styles from './Announcements.module.scss';
import DashboardApi from '../../api/DashboardApi';
import Line from '../../components/skeletons/Line';

const Announcements = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const style = { height: 228, width: '100%', borderRadius: 8, opacity: 0.7 };

  useEffect(() => {
    setLoading(true);
    DashboardApi.getAnnouncements()
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className='col-4'>
        <Line style={style} gradient={styles.gradient} />
      </div>
    );
  }

  return (
    <div className='col-4'>
      <div className={cx(styles.wrapper, 'pt-2 pe-3 ps-3 radius-4 h-100')}>
        <div className={cx(styles.date)} />
        <h6 className='title border-btm pb-3 text-gray fw-bold'>Release notes</h6>
        <div className='d-flex pt-3  align-items-center'>
          <div className='border-r w-50'>
            <div className='d-flex justify-content-center mt-3'>
              <i className={cx(styles.icon, 'icon-rocket text-success')} />
            </div>
            <p className={cx(styles.number, 'mt-2 mb-1')}>{data.web}</p>
            <p className={styles.text}>{`${'Web'}`}</p>
          </div>
          <div className='w-50 position-relative'>
            <div className={styles.vs}>VS</div>
            <div className='d-flex justify-content-center mt-3'>
              <i className={cx(styles.icon, 'icon-rocket text-warning')} />
            </div>
            <p className={cx(styles.number, 'mt-2 mb-1')}>{data.mobile}</p>
            <p className={styles.text}>{`${'Mobile'}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcements;
